import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, ValidationErrors} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import type { ColDef, GridApi } from "ag-grid-community";
import { Router, ActivatedRoute, Params } from '@angular/router';

import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { TicketAutorizacionTransporteService } from 'src/app/aplicaciones-modulos/balanza/services/ticket-autorizacion-transporte.service';
import SignaturePad from 'signature_pad';
import { ICheckDinamicoPreguntas, ICheckDinamicoRespuestas, ITrackingCheckGarita } from '../../model/modelCheckGarita';
import { MantenimientoBasculaService } from 'src/app/aplicaciones-modulos/balanza/services/mantenimiento-bascula.service';
import { MantenimientoGaritasService } from 'src/app/aplicaciones-modulos/balanza/services/mantenimiento-garitas.service';
import { UsuariosService } from 'src/app/aplicaciones-modulos/balanza/services/usuarios.service';
import { UsuarioBasculaGaritaService } from 'src/app/aplicaciones-modulos/balanza/services/usuario-bascula-garita.service';
import { ITiposPlanificacion } from '../../model/modelConfiguracional';
import { TrackingConfiguracionService } from '../../service/trackingConfiguracion.services';
import { ITicketAuthTransResp } from 'src/app/aplicaciones-modulos/balanza/modelos/ITicketAuthTransResp';
import { IBasculaSentidoRequest, IMensajesRequest } from '../../model/modelOnlyServices';
import { EquiposMarquesinaService } from '../../service/equiposMarquesinas.service';

@Component({
  selector: 'app-check-garita',
  templateUrl: './check-garita.component.html',
  styleUrls: ['./check-garita.component.css']
})

export class CheckGaritaComponent implements OnInit {
  public DAT_TITULOS = diccionarios.titulos.garita;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public rowData        : ITrackingViajes[] = [];
  public rowSelection   : any;
  public gridApi        : GridApi;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;

  // variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  //public listTipos      : ITiposViajesShort  [] = [];
  public listAgencias   : any[] = [];
  
  public cmbxEstados    : any[] = [];
  public listOpciones   : any[] = [];
  public routear        : "garita";
  public isAprobador    : boolean = false; // true solo si es el aprobador se controla por las rutas importante poner autoritis
  public isSalida       : boolean = false;
  public fechaHoraInicio : any;
  public isCheckRecurrente : boolean = false; // habilita la opción de no realizar el check por execpión
  
  public isVntContenerizada: boolean = true;  
  public checkContenerizado_recurrente : ITrackingCheckGarita;


  //FIRMA
  signatureNeeded!  : boolean;
  signaturePad!     : SignaturePad;
  @ViewChild('canvas') canvasEl!: ElementRef;
  signatureImg!     : string;

  public checkTodos = new FormControl(false);
/* 1 MODELO ANTIGUO
  public formulario = new FormGroup({
    viajeId           : new FormControl('', Validators.required),
    seguridadVial     : new FormControl('', Validators.required),
    proteccionPersonal: new FormControl('', Validators.required),
    llantasOperativas : new FormControl('', Validators.required),
    llantaEmergencia  : new FormControl('', Validators.required),
    brazoChassis      : new FormControl('', Validators.required),
    interiores        : new FormControl('', Validators.required),
    exteriores        : new FormControl('', Validators.required),
    guardiaNombre     : new FormControl('', Validators.required),
    guardiaCedula     : new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]),
    firma             : new FormControl(true),
    observacion       : new FormControl(''),
    estado            : new FormControl(''),

    urlFirma          : new FormControl(''),
    urlFoto           : new FormControl(''),

    creadoPor         : new FormControl('', Validators.required),
    modificadoPor     : new FormControl(''),
    proveedorNombre   : new FormControl(''),
    placa             : new FormControl('')
    });
*/
  public formAprobacion = new FormGroup({
    idViaje           : new FormControl('', Validators.required),
    garitaTicket      : new FormControl('', Validators.required),
    garitaNombre      : new FormControl('', Validators.required),
    estado            : new FormControl('', Validators.required),
    fechaEntrada      : new FormControl('', Validators.required),
    fechaSalida       : new FormControl(''),
    modificadoPor     : new FormControl(''),
    });


  //MODELO DINAMICO
  public formulario: FormGroup;
  public tipoCheck;

  constructor(
    private utilServices  : UtilsService,
    private dmaestrosAPI  : DatosMaestrosService,
    private logisticaAPI  : LogisticaService,
    private _catalogos    : CatalogosLogisticaService,
    private rutaActiva    : ActivatedRoute,
    private router        : Router,
    private balanzaApi    : TicketAutorizacionTransporteService,
    private fb              : FormBuilder,

    //MODELO AMPLIADO DE PLANIFICACION
    private ticketAutorizacionTransporteS: TicketAutorizacionTransporteService,
    private basculaService: MantenimientoBasculaService,
    private garitasService: MantenimientoGaritasService,
    private usuarioBasculaAPI: UsuarioBasculaGaritaService,
    private trackingConfiguracional: TrackingConfiguracionService,

    /**Integracion de servicios con equipos y sensores */
    private onlyControlSensoresAPI: EquiposMarquesinaService,
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));

    this.rutaActiva.params.subscribe((params: Params) => {
      console.log('Router-Params: ' + params.aprobar);
      this.isAprobador = params.aprobar == "aprobar";
      this.isSalida = params.aprobar == "salida";
      this.cargarGridcomponent();
      this.listar();
    });

    //Check o UnCheck Todos
    this.checkTodos.valueChanges.subscribe(valor => {
      let values = valor ? 'Si' : 'No';
      this.listOpciones.forEach(e=> this.formulario.get(e.name).setValue(values));

      //MODELO DINAMICO
      if(this.preguntasDinamicas) {
        this.checkTodoDinamicos(values);
      };

    });

    this.cargarGridcomponent();
    this.inicializar();

    this.formulario = this.fb.group({
      viajeId           : ['', Validators.required],
      seguridadVial     : ['', Validators.required],
      proteccionPersonal: ['', Validators.required],
      llantasOperativas : ['', Validators.required],
      llantaEmergencia  : ['', Validators.required],
      brazoChassis      : ['', Validators.required],
      interiores        : ['', Validators.required],
      exteriores        : ['', Validators.required],
      guardiaNombre     : ['', Validators.required],
      guardiaCedula     : ['', [Validators.required, Validators.minLength(5), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      firma             : [true],
      observacion       : [''],
      estado            : ['', Validators.required],

      urlFirma          : [''],
      urlFoto           : [''],

      creadoPor         : ['', Validators.required],
      modificadoPor     : [''],
      proveedorNombre   : [''],
      placa             : [''],
      garitaTicket      : [''],
    });

    // Para obtener api key de bascula para integracion Only Control
    this.getAllMensajesMarquesinas();
    this.getUsuarioBascula();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent,};
    this.columnDefs = this._catalogos.getColumnDefs();
    this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned:"left", width: 80, minWidth: 80, maxWidth: 80, cellRendererParams: {onClick: this.nuevo.bind(this), label: 'Editar'} },
    );

    if(this.isAprobador || this.isSalida){
      this.columnDefs.push(
        {cellRenderer: 'buttonRenderer', initialPinned:"left", width: 150, minWidth: 150, maxWidth: 150, cellRendererParams: {onClick: this.procesoGarita.bind(this), label: 'Gestionar Ticket'}},
        {cellRenderer: 'buttonRenderer', initialPinned:"left", width: 80, minWidth: 80, maxWidth: 80, cellRendererParams: {onClick: this.imprimirCheck.bind(this), label: 'Imprimir'}});
    }

  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  inicializar(){
    //this.listTipos = [];
    //this.listCentros = [];
    this.tipoViajeSelected = null;
    this.isCheckRecurrente  = false;
    this.cmbxEstados = this._catalogos.catalogoEstados();
    this.listOpciones = this._catalogos.catalogoPreguntasGarita();
    this.listar();
  
  }

  listar(){
    this.rowData = [];
    this.isCreate = false;
    this.loading = true;
    this.logisticaAPI.getViajesByEstadosGarita().subscribe((res) => {
      if(res) {
        this.rowData = res;
        if(this.isAprobador){
         // this.rowData = this.rowData.filter(e=> (e.estado == 'GARITA_REVISADA' || e.estado == 'CONVOY_PLANIFICADO'));
          this.rowData = this.rowData.filter(e=> (e.estado == 'GARITA_REVISADA'));
        }else if(this.isSalida){
          this.rowData = this.rowData.filter(e=> (e.estado == 'CONVOY_PLANIFICADO'));
        }
        else{
          //this.rowData = this.rowData.filter(e=> (e.estado == 'REVISION_HABILITADA'));
           this.rowData = this.rowData.filter(e=> (e.estado == 'REVISION_HABILITADA'));
        }
      }
      this.loading = false;
    }, (err) => {
      console.log(err.message);
      this.loading = false;
    });
  }

  selected : ITrackingViajes;
  vistaOperador:boolean = true;
  nuevo({rowData}){
    this.selected = rowData;
    this.tipoViajeSelected = rowData.tipoPlanificacion;
    console.log("viaje seleccionado", this.selected);

    this.preguntasDinamicas = [];
    this.tipoCheck = "";
    this.isCreate = true;
    this.isView   = false;

    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
    this.checkTodos.reset();
    this.formulario.reset();
    //this.formulario.markAllAsTouched();
    
    this.formulario.get('viajeId').setValue(rowData.idViaje);

    //this.vistaOperador = (rowData.estado == "REVISION_CONDICIONADA" || rowData.estado =="REVISION_ACEPTADA" || rowData.estado =="REVISION_OPERADOR_HABILITADA");
    this.vistaOperador = (rowData.estado == "REVISION_HABILITADA" || rowData.estado =="REVISION_OPERADOR_HABILITADA");
    if(!this.isAprobador || !this.isSalida){
      this.utilServices.mensajeOKToast("Se gestionará un nuevo Check de Garita");
      this.formulario.get('proveedorNombre').setValue(rowData.proveedorNombre);
      this.formulario.get('creadoPor').setValue(this.usarioActual.login2);
      this.formAprobacion.get('garitaTicket').setValue(rowData.garitaTicket);
      //Cristhiam setear control por defecto. Estado a selecion del usuario
      this.formulario.get('estado').setValue('GARITA_REVISADA');
    }else{
      this.utilServices.mensajeOKToast("Check de GARITA en "+ rowData.estado);
      this.gestionarRevision({rowData});
    }

    //Inicializa firma
    //Esperamos a que Angular renderice el canvas
    setTimeout(() => {
      if (this.canvasEl) {
        this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
      } else {
        console.error('canvasEl no está disponible todavía');
      }
    }, 0);


    //REV5 04-05-2026: refactoriza condiciones para el tipo de carga = 2
    this.isVntContenerizada = this.tipoViajeSelected.tipoEscenario == "VENTA" && this.selected.tipoCarga == 1;
    console.log("es venta contenerizada", this.isVntContenerizada);
    
    if(rowData.garitaTicket) this.getTicketGarita();
    if(this.tipoViajeSelected.generaTicketGarita) {
      this.getUsuarioBasculaGarita();
    }

    //0:INICIA EL PROCESO CON REVISIÓN VEHICULAR
    //REV1 this.tipoCheck =  rowData.estado == "REVISION_OPERADOR_HABILITADA" ? "OPERADOR" : "GARITA"; // comentado hasta que se aclare logica
    //REV2 Cristhian definir como funciona el estado con los check
    //REV3 this.tipoCheck =  rowData.estado == "REVISION_OPERADOR_HABILITADA" ? "OPERADOR" : "REVISION_VEHICULAR";
    //REV4-28-04-2026: aumenta la condición tipo compra, para que aplica check recurrente y dinamico
    /*REV5 04-05-2026: quita condición de compras, ya no aplica para tipoCarga = 2 se mantiene mantiene el check fijo RE-xxxxxA p/contenerizado*
    refactoriza condiciones para el tipo de carga = 2 */
    if(rowData.tipoCarga == 2){
        this.tipoCheck =  "REVISION_VEHICULAR";
        this.getCheckGranel();
        this.getCheckRecurrente();  // Verifica check recurrente para tipo de carga 2
    }else{
      this.getCheckContenerizadoByViaje(); //REV5 04-05-2026: refactoriza condiciones para el tipo de carga = 2
      if(!this.isVntContenerizada && this.tipoViajeSelected.tipoEscenario != "TRASLADO") this.formulario.get('estado').setValue('');
    }

  }

  public urlFirma: String;
  public isView: boolean = false;
  gestionarRevision({rowData}){
    this.isView     = true;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
    this.formulario.reset();
    this.getCheckContenerizadoByViaje();
  }

  getCheckContenerizadoByViaje(){
    const viaje: string = this.selected.idViaje.toString();
    this.logisticaAPI.getByViajeCheckGarita(viaje).subscribe((res) => {
      if(res) {
        //this.formulario.patchValue(res);
        this.formulario.get('viajeId').setValue(res.viaje.idViaje);
        this.formulario.get('firma').setValue(res.firma ? 1 : 0);
        //this.formulario.get('modificadoPor').setValue(this.usarioActual.login2);
        this.urlFirma = res.urlFirma;
        //console.log("firma url", this.urlFirma);
        if(!this.isVntContenerizada) {
          this.isCheckRecurrente = true;        
          this.checkContenerizado_recurrente  = res;
          this.checkContenerizado_recurrente.modificado = null;
          this.checkContenerizado_recurrente.modificadoPor = null;
          this.checkContenerizado_recurrente.creadoPor = this.usarioActual.login2;
        };
      }
    }, (err) => {
      console.log(err.error.mensaje);
      this.utilServices.alertifyToastWar("No existe check registrado para este viaje");
      return;
    });
  }

  /** Si el form esta en modo de creación hará post caso contrario un update, ver variable isCreated */
  saveForm() {/*
    this.getFormValidationErrors();
    if (this.formulario.invalid) return;
    this.loading = true;

    let payload   = this.formulario.getRawValue();
    payload.viaje = this.selected;
    //payload.estado = "GARITA_REVISADA";
    console.log("payload", payload);

    if(this.isCreate){
      this.savePad();
      if (this.signaturePad.isEmpty()) return this.utilServices.mensajeErrorVisto("Se requiere firmar");
      payload.capturaFirma = this.signatureImg;
    }
    */
    let mensajeP = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
    const data   = this.setPreparaDateMetodoFijo();
    console.log("payload", data);
    this.loading = true;

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        //funcion : this.isCreate ? this.logisticaAPI.createCheckGarita(data) : this.logisticaAPI.updateCheckGarita(data)
        funcion : this.logisticaAPI.createCheckGarita(data)
      }).then((response: ITrackingCheckGarita) => {
        this.inicializar();
        if(!this.isVntContenerizada) this.enviarMensajeMarquesina(response.viaje.estado);

      }).catch(() => {});

    this.loading = false;
  }


  //Acciones del formulario para guardar(modelo nuevo o recurrente) o retornar
  acciones(event) {
    if (event === 'regresar'){ 
      this.handleBack();
      return;
    }

    //solo actualiza estados
    if(this.isAprobador || this.isSalida){
      this.actualizarEstadoViaje();
      return;
    };

    //Solo para el tipo = 2, existe el modelo dinamico y recurre
    //REV5 04-05-2026: refactoriza condiciones para el tipo de carga = 2
    if (this.selected.tipoCarga == 2 || !this.isVntContenerizada) {
      console.log("1 acciones");
      this.saveModel(event === "MODEL_RECURRENTE");
      return;
    }

    this.saveForm();

  }


  //Modelo de procesos, fijo, dinamico dependiendo si genera o no ticket garita
  private saveModel(saveModeloRecurrente): void {
    if (this.tipoViajeSelected.generaTicketGarita && this.formulario.get('estado').value == "REVISION_ACEPTADA") {
      this.generarTGarita(saveModeloRecurrente);
    } else {
      if (!this.isVntContenerizada) return this.saveForm();
      this.saveFormModeloNuevo();
    }
  }

  private handleBack(): void {
    this.isCreate = false;
    this.isCheckRecurrente = false;
    this.tipoViajeSelected = null;
    this.closeModal();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    //document.getElementById('cerrarModal').click();
    document.getElementById('cerrarModal2').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');
    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  /** METODOS DE CONSULTAS  */
  actualizarEstadoViaje(){
    //rowData.estado = "GARITA_APROBADO";
    this.getFormValidationAPROBARErrors();
    if (this.formAprobacion.invalid) return;

    let form = this.formAprobacion.getRawValue();
    let mensaj = form == "CONVOY_PLANIFICADO" ? diccionarios.mensajes.garitaFinalizar : diccionarios.mensajes.garitaAprobar ;
    console.log("this selected ==>", this.selected);
    this.selected.estado = form.estado;
    this.selected.garitaTicket = form.garitaTicket;
    this.selected.areaId ??= 0;
    this.selected.modificadoPor = form.modificadoPor;
    this.selected.fechaInicioProceso = this.fechaHoraInicio;
    const payload = this.selected;
    console.log("Actualizar estado del viaje a ==>", form.estado);
    console.log("Objeto viaje ==>", payload);
    //this.gestionarRevision({rowform}); NO entiendo porque hice esto revisar Karina

    this.utilServices.confirmarSincronoPromesa({
        title   : mensaj,
        text    : 'VIAJE ' + form.idViaje,
        action  : "Actualizar Viaje",
        funcion : this.logisticaAPI.updateViaje(payload)
      }).then((res: ITrackingViajes) => {
        this.loading = false;

        if(res.estado == 'FINALIZADO') {
          this.logisticaAPI.updateNextViajeCola(res.areaId, this.usarioActual.login2).subscribe((res) => {
              this.utilServices.alertatoastOK("Habilita viaje =>" + res.idViaje);
          });
        }
        
        if(this.selected.estado == 'APROBAR_GARITA') this.actualizaEstadoGarita(form);
        this.listar();
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  // clave: 7, valor: 'GARITA_APROBADO'
  actualizaEstadoGarita(rowData){
    let payload  = this.formulario.getRawValue();

    payload.estado  = 7;
    payload.viaje   = rowData;
    const data      = payload;

    console.log("traza para actualizar garita", data);
    this.logisticaAPI.updateCheckGarita(data).subscribe((res) => {
      if(res) this.utilServices.mensajeOKToast("Check de Garita Aprobado");
    }, (err) => {
      console.log(err.message);
       this.utilServices.mensajeErrorVisto("Probrlemas con actualizar Garita Aprobado");
    });
  }

  imprimirCheck({rowData}){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/traslado-logist/reporte-inspeccion/', rowData.idViaje])
    );
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  getTicketGarita(){
    const ticketGarita = this.formAprobacion.get('garitaTicket').value;
    this.formAprobacion.get('fechaEntrada').reset();
    this.formAprobacion.get('fechaSalida').reset();
    this.formAprobacion.get('garitaNombre').reset();

    if(ticketGarita > 0){
      this.balanzaApi.obtenerPorId(ticketGarita).subscribe((res) => {
        if(res) {
          this.formAprobacion.get('fechaEntrada').setValue(res.fecha);
          this.formAprobacion.get('fechaSalida').setValue(res.fechaSalida);
          this.formAprobacion.get('garitaNombre').setValue(res.idGarita.desca);
        };
      }, (err) => {
        console.log(err.message);
      });
    }

  }

  /* Garita tiene 2 procesos de aprobar la revision y de autorizar la salida,
  en primer estado es GARITA APROBADO y el segundo es FINALIZAR el proceso.*/
  procesoGarita({rowData}){
    this.selected = rowData;
    this.isCreate = false;
    this.isCheckRecurrente = false;

    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
    let validaciones = rowData.estado == 'CONVOY_PLANIFICADO';

    if(rowData.estado != 'GARITA_APROBADO'){
        this.titleModal =  validaciones ? "Autorizar Salida" :  "Aprobar revisión de Garita";
        const estado    =  validaciones ? "FINALIZADO" :  "GARITA_APROBADO";

        this.formAprobacion.reset();
        this.formAprobacion.patchValue(rowData);

        this.formAprobacion.get('fechaSalida').setValidators([]);
        this.formAprobacion.get('fechaSalida').updateValueAndValidity();
        this.formAprobacion.get('estado')?.disable({ onlySelf: true });
        this.formAprobacion.get('estado').setValue(estado);
        this.getTicketGarita();

        if(validaciones){
          this.formAprobacion.get('fechaSalida').setValidators([Validators.required]);
          this.formAprobacion.get('fechaSalida').updateValueAndValidity();
          if(this.formAprobacion.get('fechaSalida')) this.utilServices.alertifyToastWar("Garita no ha realizado salida del vehículo");
        }
        document.getElementById('fillOne').click();
    }else{
      this.utilServices.mensajeErrorVisto("Proceso ya Aprobado");
    }

    //MODELO DINAMICO
    /*
    if(rowData.tipoCarga == 2){
      this.getTipoViaje();
      this.getUsuarioBasculaGarita();
    } */  

  }

  getFormValidationAPROBARErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');
    let totalErrors = 0;

    Object.keys(this.formAprobacion.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formAprobacion.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }



  /* METODOS DE LA FIRMA */
  startDrawing(event: Event) {
      // works in device not in browser
  }

  moved(event: Event) {
      // works in device not in browser
  }

  // luego agregar esto al form data para enviar el formulario
  savePad() {
    const base64Data = this.signaturePad.toDataURL();
    this.signatureImg = base64Data;

    console.log(`Tamaño aproximado firma base64: ${Math.round(base64Data.length / 1024)} KB`);

    this.signatureNeeded = this.signaturePad.isEmpty();
    if (!this.signatureNeeded) {
      this.signatureNeeded = false;
    }
  }

  clearPad() {
    this.signaturePad.clear();
  }

  //Manejo de imagenes
  imagenes: File[] = [];
  errorArchivos: string = '';
  onFileSelected(event: Event){
    const fileInput = event.target as HTMLInputElement;
    if (!fileInput.files) return;

    const archivos = Array.from(fileInput.files);
    const archivosValidos = archivos.filter(file =>
      ['image/png', 'image/jpeg'].includes(file.type)
    );

    if (archivosValidos.length !== archivos.length) {
      this.errorArchivos = 'Algunos archivos no son PNG o JPG válidos.';
      this.imagenes = [];
      return;
    }

    this.imagenes = archivosValidos;
    this.errorArchivos = '';
  }


  //formData.append('fotos', file, file.name)
  setFormData(data: any): FormData {
    const formData = new FormData();
    if (this.imagenes.length > 0) {
      this.imagenes.forEach((file) => {formData.append('imagenes', file);}); // archivos
    }

    Object.entries(data).forEach(([key, value]) =>formData.append(key, value as string)); // campos texto
    formData.delete('viaje');
    formData.append('capturaFirma', this.signatureImg);
    formData.append('viaje', JSON.stringify(data.viaje));

    return formData;
  }


  /**Adaptaciones para check nuevos
   * Registros RE-10200B, pregunta por partes según modulo
   * Modelo de maestro de preguntas y respuestas
   * Renderización de formulario dinamico
  */

  tipoViajeSelected : ITiposPlanificacion;
  getTipoViaje(){
    this.tipoViajeSelected = null;
    const tipo = this.selected?.tipo;
    this.trackingConfiguracional.getTipoById(tipo).subscribe((res: ITiposPlanificacion) => {
      if(res){
        this.tipoViajeSelected = res;
        this.formAprobacion.get('garitaTicket')?.disable({ onlySelf: true });
      };
    },() => {
      this.loading = false;
    });

  }

  preguntasDinamicas: ICheckDinamicoPreguntas[]=[];
  getCheckGranel(){
    this.logisticaAPI.getCheckByRegistroModulo('RE-10200B', this.tipoCheck).subscribe((res) => {
      if(res){
        this.preguntasDinamicas = res;
        this.preguntasDinamicas.forEach(e=> {e.renderControl = 'pregunta_' + e.idItem});
        console.log("nuevas preguntas", this.preguntasDinamicas);
        this.formulario.get('guardiaNombre').setValue("x");
        this.formulario.get('guardiaCedula').setValue("1312170077");
        this.formulario.get('creadoPor').setValue(this.usarioActual.login2);
        /*this.formulario.get('estado').addValidators(Validators.required);
        this.formulario.updateValueAndValidity();*/
        if(this.isView){
          this.getCheckRespuestas();
        }
      }
    }, (err) => { console.info(err.message); });
  }

  getCheckRespuestas(){
    this.logisticaAPI.getCheckByRespuestas(this.selected.idViaje).subscribe((res) => {
      if(res){
        this.urlFirma = res[0].urlFirma;
        res.forEach(e => {
          const renderControl = 'pregunta_' + e.checklistMaestro.idItem;
          const tipoRespuesta = e.checklistMaestro.tipoRespuesta;

          switch (tipoRespuesta) {
            case 'SI_NO_NA':
              this.formulario.get(renderControl).setValue(res.respuestaCheck);
              break;
            case 'TEXT':
              this.formulario.get(renderControl).setValue(res.respuestaTexto);
              break;
            case 'NUMBER':
              this.formulario.get(renderControl).setValue(res.respuestaNum);
              break;
            default:
              console.log('Valor no reconocido');
              break;
          }
        });
      }
    }, (err) => { console.info(err.message); });
  }
  
  //DTO para envio de RespuestasDTO
  dataRespuestas(){
    let respuestas: ICheckDinamicoRespuestas[]=[];
    
    //let estadoViaje = "REVISION_OPERADOR_HABILITADA"; //•	RF-13 - Revisión Física (Operador Despacho) – RE-10200B
    //31032026 Cristhian ya no va a GARITA REVISADA ahora a REVISION ACEPTADA
    /*if(this.selected.estado == "REVISION_OPERADOR_HABILITADA" ){
      estadoViaje = "GARITA_REVISADA";
    }*/
    //descontinua ahora depende de la seleccion del combo
    //estadoViaje = "REVISION_ACEPTADA"; //CRISTHIAN POR CONFIRMAR SI CORRESPONDE A ESTE ESTADO Y SI NO HAY LOGICA CON EL ESTADO ANTERIOR
    //kary: si me vuelven a pedir cambio pedir definicion escrita

    let estadoViaje = this.formulario.get('estado')?.value; //Cambio de Cristhuan ahora depende de la seleccion del usuario
    
    this.preguntasDinamicas.forEach(e=>{
      const item = {
        viajeId : this.selected.idViaje,
        itemId  : e.idItem,
        respuestaCheck : e.tipoRespuesta == "SI_NO_NA" ? this.formulario.get(e.renderControl)?.value : null,
        respuestaTexto : e.tipoRespuesta == "TEXT" ? this.formulario.get(e.renderControl)?.value : "-",
        respuestaNum   : e.tipoRespuesta == "NUMBER" ? this.formulario.get(e.renderControl)?.value : 0,
        inspeccionadoPorUsuario : this.usarioActual.login2,
        inspeccionadoPorCedula : this.usarioActual.login,
        urlFirma    : null,
        urlFotos    : null,
        creadoPor   : this.usarioActual.login2,
        checklistMaestro: e,
        itemPregunta    : e.idItem,
        tipoRespuesta   : e.tipoRespuesta,
        estadoViaje     : estadoViaje,
      };
      respuestas.push(item);
    });

    let payload = {
      imagenes: [],
      capturaFirma : this.signatureImg,
      ticketGarita : this.formulario.get('garitaTicket').value,
      respuestas  : respuestas,
    };

    console.log("datos preparados para envio", payload);
    return payload;
  }

  checkTodoDinamicos(value){
    const valor = value == 'Si' ? "1" : "0";
    this.preguntasDinamicas.forEach(e => {
      if(e.tipoRespuesta == 'SI_NO_NA' ){
        this.formulario.get(e.renderControl).setValue(valor);
      }
    });
  }

  saveFormModeloNuevo(esRecurrente:boolean = false) {
    console.log("almacen final, es recurrente", esRecurrente );
    if(esRecurrente) return this.saveModeloRecurrente();

    this.getFormValidationErrors();
    if (this.formulario.invalid) return;

    if(this.isCreate){
      this.signatureNeeded = this.signaturePad.isEmpty();
      if (this.signatureNeeded) return this.utilServices.mensajeErrorVisto("Se requiere firmar");
      this.savePad();
    }
    let payload  = this.dataRespuestas();
    let mensajeP = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
    this.loading = true;

    //Envio de mensaje de marquesina
    this.enviarMensajeMarquesina(this.formulario.get("estado").value);
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.logisticaAPI.createCheckByRespuestasList(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
        this.acciones('regresar');

      }).catch(() => {});
      this.loading = false;
  }


  // obtiene el usuario para garita
  garitaUsuario : any;
  getUsuarioBasculaGarita(){
    const username =this.usarioActual.login2;
    this.usuarioBasculaAPI.obtenerPorUsuario(username, "garita").subscribe(
      resp => {
        if (resp.garita) {
          let miGarita = {
            idGarita  : resp.garita,
            estado    : this.signatureImg,
            desca     : resp.garitaDescripcion,
          };
          this.garitaUsuario = miGarita;
          this.formAprobacion.get('garitaNombre').setValue(resp.garitaDescripcion);
          return;
        }
        this.utilServices.mensajeErroToast('No tiene una garita asignada.');
      },
      error => {
        this.utilServices.mensajeErroToast('Ocurrió un error al buscar la garita asignada, inténtelo nuevamente.');
      }
    );
  }

  //SIEMPRE QUE APLICA GENERA TICKET DE GARITA
  generarTGarita(saveModeloRecurrente){
    let data = {
      placa             : this.selected.placa,
      proveedor         : this.selected.proveedorCompra,
      chofer            : this.selected.choferNombre,
      cedula            : this.selected.choferCedula,
      estado            : "ACTIVO",
      idTipoOrd         : 5,
      observacion       : "Proceso automatico. " + this.formulario.get('observacion').value,
      proveedorTransp   : this.selected.proveedorId,
      estadoControlEntrada: 1,
      sellos            : this.selected.sellos,
      cliente           : this.selected.cliente,
      pesoBrutoRecibido : this.selected.cantidadDespacho,
      referenciaProducto: this.selected.materialId,
      facturaGuia       : this.selected.orden,
      lugarSalida       : this.selected.centroOrigen ? this.selected.centroOrigen +"-"+this.selected.centroOrigenNombre : "",
      lugarLlegada      : this.selected.centroDestino ? this.selected.centroDestino +"-"+this.selected.centroDestinoNombre : "",
      idGarita          : this.garitaUsuario,
      ordenFlete        : this.selected.orden,
      fechaLlegada      : this.selected.fechaLlegada,
      usuario           : this.usarioActual.login2,
      tanqueroId        : this.selected.tanquero
    };

    this.utilServices.confirmarSincronoPromesa({
        title   : "Crear Check y Ticket Garita",
        text    : "Desea generar un Ticket Garita para la planificacion-viaje  " + this.selected.idViaje,
        action  : "Nuevo",
        funcion : this.ticketAutorizacionTransporteS.crear(data),
      }).then((e: ITicketAuthTransResp) => {
        //Aqui llenar el ticket nuevo
        console.log("respuesta ticket garita creado", e);
        this.formAprobacion.get('garitaTicket').setValue(e.idAuthTransp); // descontinua proceso en formAprobacion y se une directamente en el check
        this.formAprobacion.get('fechaEntrada').setValue(e.fecha);
        this.formAprobacion.get('fechaSalida').setValue(e.fechaSalida);
        this.formulario.get('garitaTicket').setValue(e.idAuthTransp);

        this.utilServices.mensajeOKVisto("Ticket Transporte Creado " + e.idAuthTransp, true, 5000);
        //this.saveFormModeloNuevo();
        //this.getTicketGarita();

        //MODELO RECURREENTE O NO RECURRENTE
        /*if(saveModeloRecurrente){
          console.log("ENTRO COMO RECURRENTE", saveModeloRecurrente);
          this.saveModeloRecurrente();
          return;
        }*/

        if(this.selected.tipoCarga == 1) this.saveFormContenerizadoConTGarita(saveModeloRecurrente);
        if(this.selected.tipoCarga == 2) this.saveFormModeloNuevo(saveModeloRecurrente);

        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
  }

  // metodos para manejo del modelo recurrente
  viajeReferencia: ICheckDinamicoRespuestas;
  getCheckRecurrente(){
    this.isCheckRecurrente = false;
    const viaje = this.selected.idViaje;

    this.logisticaAPI.getCheckRecurrente(viaje).subscribe((res) => {
      if(res) {
        this.isCheckRecurrente = true;
        this.viajeReferencia = res[0];
        this.formulario.get('observacion').setValue("CHECK RECURRENTE VIAJE REFERENCIA: "+ this.viajeReferencia.viajeId);
      };
    },() => {
      this.loading = false;      
    });

  }

  saveModeloRecurrente() {
    let item = {
      viajeId                 : this.selected.idViaje,
      viajeRecurrente         : this.viajeReferencia.viajeId,
      observacion             : "CHECK RECURRENTE VIAJE REFERENCIA: " + this.viajeReferencia.viajeId,
      inspeccionadoPorUsuario : this.usarioActual.login2,
      inspeccionadoPorCedula  : this.usarioActual.login,
      creadoPor               : this.usarioActual.login2,
      estadoViaje             : "REVISION_ACEPTADA",
      ticketGarita            : this.formulario.get('garitaTicket').value,
    };
    const payload = item;
    console.log("envio de recurrente 0", item);
    console.log("envio de recurrente 1", payload);
  
    this.loading = true;
    this.logisticaAPI.saveCheckRecurrente(item).subscribe(
      (data) => {
        console.log("respuesta check recurrente", data);
        //this.acciones('regresar');
      }, 
      (err) => {  console.log(err.message); },
      () => console.log("terminó")
    );

    /*
    this.logisticaAPI.saveCheckRecurrente(item).subscribe({
      next: (data) => {
        console.log("respuesta check recurrente", data);
        //this.acciones('regresar');
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
        console.log('finalizado');
      }
    });*/

    this.loading = false;
  }

  setPreparaDateMetodoFijo(esModeloReccurente: false = false){
    this.getFormValidationErrors();
    if (this.formulario.invalid) return this.utilServices.alertifyToastWar("Datos invalidos");

    let payload   = this.formulario.getRawValue();
    if(esModeloReccurente) payload = this.getCheckContenerizadoByViaje;
    payload.viaje = this.selected;
    payload.viaje.garitaTicket = payload.garitaTicket;

    if(this.isCreate){
      this.savePad();
      if (this.signaturePad.isEmpty()) return this.utilServices.mensajeErrorVisto("Se requiere firmar");
      payload.capturaFirma = this.signatureImg;
    }

    return payload;
  }

  //save para tipo contenerizado que no sean ventas
  saveFormContenerizadoConTGarita(esModeloReccurente){
    const data   = this.setPreparaDateMetodoFijo(esModeloReccurente);
    console.log("payload contenerizado", data);
    this.loading = true;

    this.logisticaAPI.createCheckGarita(data).subscribe((res) => {
      if(res) {
        this.utilServices.mensajeOKVisto("Check Garita Creado con Éxito");
        this.loading = false;
        this.enviarMensajeMarquesina(res.viaje.estado); 
        this.inicializar();
      };
    },(error) => {
      console.log(error);
      this.utilServices.mensajeErrorVisto(error.message);
    });    

  }
  
  /**INTEGRACION ONLY CONTROL
   * USUARIO Y BALANZA, INICIALIZA SERVICIOS Y ENVIA MENSAJES
   */
  
  //Obtiene el usuario para garita o bascula
  basculaUsuario : any;
  getUsuarioBascula(){
    const username =this.usarioActual.login2;
    this.usuarioBasculaAPI.obtenerPorUsuario(username, "bascula").subscribe(
      resp => {
        if (resp?.bascula) {
          let bascula = {
            idBascula: resp.bascula, 
            estado: resp.estadoBascula, 
            desca: resp.basculaDescripcion,
            sensorId: resp.sensorId,
            apiKey: resp.apiKey,
          };
          this.basculaUsuario = bascula;

          //Verifica test de conexión siempre que tenga Api Key
          if (resp.sensorId != null) {
            this.onlyControlSensoresAPI.setIntegration_ApiKey(resp.sensorId);
          }
          return;
        }
      },
      e => {console.error('Mensaje: ', e.error.mensaje, 'Respuesta', e.error.respuesta);}
    );
  }

  mensajesMarquesinas=[]; 
  getAllMensajesMarquesinas(){
    this.logisticaAPI.getMarquesinaMensajes().subscribe(resp => {
      if(resp){
        this.mensajesMarquesinas = resp;
      }
      console.log("mensajes marquesiana", this.mensajesMarquesinas);
    });
  }

  enviarMensajeMarquesina(tipoMensaje: String){
    console.log("buscar mensaje según estado", tipoMensaje);
    let filterMnsj = this.mensajesMarquesinas.find(e=> e.tipo === tipoMensaje);
    let lineasMnsj = filterMnsj ? filterMnsj.mensaje.split(",").map(m => ({texto: m.trim()})) : [];

    if(filterMnsj.indicador > 0) this.setearSentidoBascula(filterMnsj.indicador);

    if(lineasMnsj.length == 0){
      console.info("Marquesina sin mensajes", lineasMnsj.length);
      this.utilServices.alertifyToastWar("Sin mensajes para marquesina " + filterMnsj.marquesina.codigo);
      return;
    }

    const request: IMensajesRequest = {
      codigoBascula     : filterMnsj.marquesina.codigo,
      mensajesMarquesina: lineasMnsj
    };

    this.onlyControlSensoresAPI.postMensaje(request).subscribe(
      (resp) => {
        console.log(resp);
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error de Envio de mensajes", resp.detalle, 3000);    
          return; 
        }
        this.utilServices.alertifyToastOK("Mensaje de entrada enviado a la marquesina");
      },
      (error) => {
        this.utilServices.mensajeErrorVisto("Error en establecer mensaje");
        console.log("Error en establecer mensaje", error);
      }
    );
  }

  //Recibe sentido 1 o 2 dependiente si es Entrada o Salida
  setearSentidoBascula(sentido: number){
    const request: IBasculaSentidoRequest = {
      codigoBascula: this.basculaUsuario.sensorId,
      sentido: sentido
    };
    
    this.onlyControlSensoresAPI.postSentidoBascula(request).subscribe(
      (resp) => {
        this.utilServices.alertifyToastOK("Sentido establecido");
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error en establicer sentido", resp.detalle, 3000);
          return;
        }
      },
      (error) => {
        this.utilServices.mensajeErroToast("Error en establecer sentido");
        console.log("Error en establecer sentido", error);
      }
    );
  }

}